import React, { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import { WebRoutes } from "@constants/WebRoutes";

import { SchoolManagementView } from "./SchoolManagement.View";

const initSchool = {
    id: "",
    schoolNumber: 0,
    name: "",
    schoolDeliveryType: "",
    digiDeliveryId: "",
    schoolActiveNextYear: null,
};

function SchoolManagementPage() {
    const tableTemplateRef = useRef(null);
    const navigate = useNavigate();
    const [activeSchool, setActiveSchool] = useState(initSchool);

    //#region Handlers
    function handleManageDeadlinesButtonClick(schoolId) {
        navigate(`${WebRoutes.SchoolDeadlineManagementPage}/?schoolId=${schoolId}`);
    }

    //#endregion

    return (
        <SchoolManagementView
            activeSchool={activeSchool}
            tableTemplateRef={tableTemplateRef}
            onManageDeadlinesButtonClick={handleManageDeadlinesButtonClick}
        />
    );
}

export default SchoolManagementPage;
